import { env } from '@/env';
import type { ChallengeDTO } from '@/types/qduels';
import { ChallengesPanel } from './ChallengesPanel';
import { SfideDiPiattaformaTab } from './SfideDiPiattaformaTab';

/**
 * IL TAB «SFIDE» di Amici, in un posto solo (v3 fase 2, PR 7-bis): lo montano `Friends.tsx` (`?tab=duels`) e la chiave SFIDE di Clash Royale della v3. Le sfide di piattaforma (Limulo +
 * `beta`, `SfideDiPiattaformaTab`) e quelle di QDuels (`ChallengesPanel`, acceso con `env.featureQduelsEnabled`) stanno una sopra l'altra, com'e' sempre stato.
 */

export function PannelloSfide({
  piattaforma,
  incoming,
  incomingLoading,
  incomingError,
  soloGiochi,
}: {
  piattaforma: boolean;
  incoming: ChallengeDTO[];
  incomingLoading: boolean;
  incomingError: boolean;
  /** Solo le sfide di piattaforma di questi giochi (`gameId` del catalogo): la chiave SFIDE di un gioco. Assente = tutte, come in Amici. Le sfide di QDuels sono gia' tutte di Clash Royale. */
  soloGiochi?: ReadonlySet<string>;
}) {
  return (
    <>
      {piattaforma && <SfideDiPiattaformaTab soloGiochi={soloGiochi} />}
      {env.featureQduelsEnabled && (
        <ChallengesPanel incoming={incoming} incomingLoading={incomingLoading} incomingError={incomingError} />
      )}
    </>
  );
}
